import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, mergeMap, tap } from 'rxjs';
import { ServicePathsSettings } from 'src/app/core/configuration/service-paths-settings';
import { SectionsServiceTsService } from 'src/app/pda/utils/Service/sections.service.ts.service';

@Injectable({
  providedIn: 'root'
})
export class SchedulesServiceTsService {

  importDatiSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(private http: HttpClient, private sectionService: SectionsServiceTsService) { }

  getSchedules(idFascicoloPct):Observable<any> {
    return this.http.get<any>(ServicePathsSettings.URL_GET_SECTIONS(idFascicoloPct, 'adempimenti'));
  }

  importScadenze(token, idFascicoloTlf: string, idFascicoloPct: string, scadenze: string[]): Observable<any>{
    let req = {listaIdScadenze: scadenze};
    let url = ServicePathsSettings.URL_IMPORT_SCADENZE_PCT.replace("{idFascicoloPct}", idFascicoloPct);
    return this.http.post<any>(url, req).pipe(
      mergeMap(() => this.sectionService.updatePCT(token, idFascicoloTlf, "adempimenti"))
    );
  }

  onNextImportScadenze(){
    this.importDatiSubject.next(null);
  }

}
